{
  "name": "@beautyapp-web/source",
  "version": "5.70.2",
  "license": "MIT",
  "scripts": {
    "prepare": "husky",
    "start": "nx run beauty:serve",
    "start:https": "nx serve beauty --ssl",
    "start:test": "nx run beauty:serve:test",
    "start:test:https": "nx run beauty:serve:test --ssl",
    "start:notification-server": "ts-node apps/beauty/src/server.ts",
    "build:beauty:prod": "nx run beauty:build:production",
    "build:beauty:test": "nx run beauty:build:test",
    "release": "standard-version",
    "release:major": "standard-version --release-as major",
    "release:minor": "standard-version --release-as minor",
    "release:patch": "standard-version --release-as patch",
    "sentry:sourcemaps": "npx @sentry/cli --url https://sentry.webapp.ge/ sourcemaps inject --org sentry --project beautyapp-web ./dist/apps/beauty/browser && npx @sentry/cli --url https://sentry.webapp.ge/ sourcemaps upload --org sentry --project beautyapp-web ./dist/apps/beauty/browser",
    "sentry:set-commits": "npx @sentry/cli releases set-commits beautyapp-web@$(node -e \"console.log(require('./package.json').version)\") --ignore-missing --auto",
    "sentry:finalize": "npx @sentry/cli releases finalize beautyapp-web@$(node -e \"console.log(require('./package.json').version)\")",
    "sentry:full-release": "node scripts/sentry-release.js",
    "sentry:create": "npx @sentry/cli releases new beautyapp-web@$(node -e \"console.log(require('./package.json').version)\")",
    "sentry:upload": "npx @sentry/cli releases files beautyapp-web@$(node -e \"console.log(require('./package.json').version)\") upload-sourcemaps ./dist/apps/beauty/browser --rewrite",
    "sentry:release": "npm run sentry:create && npm run sentry:set-commits && npm run sentry:upload && npm run sentry:finalize",
    "generate-vapid-keys": "ts-node apps/beauty/src/generate-vapid-keys.ts",
    "e2e": "nx e2e beauty",
    "e2e:report": "npx playwright show-report dist/.playwright/apps/beauty/playwright-report",
    "e2e:junit": "ls -la dist/.playwright/apps/beauty/junit.xml"
  },
  "engines": {
    "node": ">=20.0.0"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "20.3.9",
    "@angular/common": "20.3.9",
    "@angular/compiler": "20.3.9",
    "@angular/core": "20.3.9",
    "@angular/fire": "^20.0.1",
    "@angular/forms": "20.3.9",
    "@angular/google-maps": "20.2.9",
    "@angular/platform-browser": "20.3.9",
    "@angular/platform-browser-dynamic": "20.3.9",
    "@angular/router": "20.3.9",
    "@angular/service-worker": "20.3.9",
    "@ant-design/icons-angular": "^20.0.0",
    "@antv/g2plot": "^2.4.33",
    "@ckeditor/ckeditor5-angular": "^9.1.0",
    "@ckeditor/ckeditor5-build-classic": "^44.2.1",
    "@ckeditor/ckeditor5-image": "^44.2.1",
    "@fingerprintjs/fingerprintjs": "^4.5.1",
    "@fontsource/firago": "^5.1.0",
    "@fullcalendar/adaptive": "~6.1.15",
    "@fullcalendar/angular": "~6.1.15",
    "@fullcalendar/core": "~6.1.15",
    "@fullcalendar/daygrid": "~6.1.15",
    "@fullcalendar/interaction": "~6.1.15",
    "@fullcalendar/list": "~6.1.15",
    "@fullcalendar/moment": "~6.1.15",
    "@fullcalendar/moment-timezone": "~6.1.15",
    "@fullcalendar/multimonth": "~6.1.15",
    "@fullcalendar/resource": "~6.1.15",
    "@fullcalendar/resource-timegrid": "~6.1.15",
    "@fullcalendar/resource-timeline": "~6.1.15",
    "@fullcalendar/scrollgrid": "~6.1.15",
    "@growthbook/growthbook": "^1.3.1",
    "@ngneat/until-destroy": "^10.0.0",
    "@ngx-translate/core": "^17.0.0",
    "@ngxs/devtools-plugin": "^20.1.0",
    "@ngxs/form-plugin": "^20.1.0",
    "@ngxs/router-plugin": "^20.1.0",
    "@ngxs/storage-plugin": "^20.1.0",
    "@ngxs/store": "^20.1.0",
    "@sentry/angular": "^10.25.0",
    "@sentry/cli": "^2.50.2",
    "@simplewebauthn/browser": "^13.2.2",
    "autoprefixer": "^10.4.18",
    "bpg-arial": "^1.0.0",
    "bpg-arial-caps": "^1.0.1",
    "ckeditor5": "^44.1.0",
    "ckeditor5-premium-features": "^44.1.0",
    "date-fns": "^4.1.0",
    "driver.js": "^1.9.0",
    "font-larisome": "^2.2.3",
    "lodash": "^4.17.21",
    "mammoth": "^1.11.0",
    "moment": "^2.30.1",
    "ng-zorro-antd": "^20.4.1",
    "ngx-clarity": "^2.3.0",
    "ngx-color-picker": "^20.1.1",
    "ngx-device-detector": "^10.1.0",
    "ngx-mask": "^20.0.3",
    "ngx-permissions": "^19.0.0",
    "ngx-spinner": "^19.0.0",
    "perfect-scrollbar": "^1.5.5",
    "postcss": "^8.4.35",
    "posthog-js": "^1.202.2",
    "rxjs": "~7.8.0",
    "socket.io-client": "^4.8.3",
    "tailwindcss": "^3.4.1",
    "tslib": "^2.3.0",
    "uuid": "^11.1.0",
    "xlsx": "^0.18.5",
    "zone.js": "0.15.0"
  },
  "overrides": {
    "ora": "^5.4.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "20.3.9",
    "@angular-devkit/core": "20.3.9",
    "@angular-devkit/schematics": "20.3.9",
    "@angular/cli": "~20.3.0",
    "@angular/compiler-cli": "20.3.9",
    "@angular/language-service": "20.3.9",
    "@angular/pwa": "20.3.9",
    "@commitlint/cli": "^19.5.0",
    "@commitlint/config-angular": "^19.5.0",
    "@commitlint/config-conventional": "^19.5.0",
    "@eslint/js": "^9.8.0",
    "@nx/angular": "22.0.4",
    "@nx/devkit": "22.3.3",
    "@nx/eslint": "22.0.4",
    "@nx/eslint-plugin": "22.0.4",
    "@nx/jest": "22.0.4",
    "@nx/js": "22.0.4",
    "@nx/playwright": "^22.3.3",
    "@nx/web": "22.0.4",
    "@nx/workspace": "22.0.4",
    "@playwright/test": "^1.57.0",
    "@schematics/angular": "20.3.9",
    "@sentry/cli": "^2.32.1",
    "@swc-node/register": "~1.9.1",
    "@swc/core": "~1.5.7",
    "@swc/helpers": "~0.5.11",
    "@types/body-parser": "^1.19.5",
    "@types/cors": "^2.8.17",
    "@types/express": "^4.17.21",
    "@types/jest": "^29.5.12",
    "@types/lodash": "^4.17.11",
    "@types/node": "^18.16.9",
    "@types/web-push": "^3.6.3",
    "@typescript-eslint/utils": "^8.33.1",
    "angular-eslint": "20.6.0",
    "autoprefixer": "^10.4.0",
    "baseline-browser-mapping": "^2.9.19",
    "body-parser": "^1.20.2",
    "cors": "^2.8.5",
    "eslint": "^9.28.0",
    "eslint-config-prettier": "10.1.5",
    "eslint-plugin-playwright": "^1.6.2",
    "express": "^4.18.2",
    "husky": "^9.1.6",
    "jest": "^29.7.0",
    "jest-environment-jsdom": "^29.7.0",
    "jest-preset-angular": "14.6.2",
    "ng-packagr": "20.3.2",
    "npm": "^10.9.0",
    "nx": "22.0.4",
    "postcss": "^8.4.5",
    "prettier": "^2.6.2",
    "standard-version": "^9.5.0",
    "tailwindcss": "^3.0.2",
    "ts-jest": "29.4.5",
    "ts-node": "10.9.1",
    "tslib": "^2.3.0",
    "typescript": "5.9.3",
    "typescript-eslint": "^8.33.1",
    "web-push": "^3.6.7"
  }
}
